<template>
  <select-fi
    v-if="!isFite"
    class="fact-finder-facet-fi"
    :open="open"
    :name="name"
    :disabled="facet.disabled"
    :mobile-inline="isSliderFacet"
    large
    @toggle-open="toggleOpen"
    @close="$emit('close')"
    @change="(...params) => $emit('change', ...params)"
  >
    <template #selectionMobile>
      <template v-if="facet.type === 'TEXT'">
        <template v-for="element in facet.elements">
          <template v-if="element.selected">
            {{ element.text }}
          </template>
        </template>
      </template>
      <template v-else>
        <template v-for="element in facet.elements">
          <span
            v-if="element.selected"
            :key="element.name"
          >
            {{ element.selectedMinValue }} {{ facet.unit }} - {{ element.selectedMaxValue }}
            {{ facet.unit }}
          </span>
        </template>
      </template>
    </template>
    <fact-finder-text-facet
      v-if="facet.type === 'TEXT'"
      :facet="facet"
      @change="onChange"
      @close="onClose"
    />
    <fact-finder-slider-facet
      v-else-if="isSliderFacet"
      :group="facet"
      @change="onChange"
      @close="onClose"
    />
    <div v-else>{{ facet.name }} {{ facet.type }}</div>
  </select-fi>

  <div
    v-else
    class="fact-finder-facet-fi"
  >
    <div class="fact-finder-facet-fi__label">
      {{ name }}
    </div>
    <fact-finder-fite-checkbox-fi
      :facet="facet"
      @change="onChange"
    />
  </div>
</template>

<script setup lang="ts">
import { SelectFi } from 'atoms';
import { computed, getCurrentInstance, onMounted, watch } from 'vue';

import factFinderNgNameCleaner from '@/components/search-fact-finder-fi/factFinderNgNameCleaner';

import FactFinderFiteCheckboxFi from '../fact-finder-fite-checkbox-fi/FactFinderFiteCheckboxFi.vue';
import type { Facet } from './fact-finder-facet-type';
import FactFinderSliderFacet from './fact-finder-slider-facet/FactFinderSliderFacet.vue';
import FactFinderTextFacet from './fact-finder-text-facet/FactFinderTextFacet.vue';

defineOptions({ name: 'FactFinderFacetFi' });

const props = withDefaults(
  defineProps<{
    facet: Facet;
    open?: boolean;
    idx?: number | null;
    registerDomElement?: ((el: any) => void) | null;
  }>(),
  {
    open: false,
    idx: null,
    registerDomElement: null,
  },
);

const emit = defineEmits<{
  (e: 'change', ...params: any[]): void;
  (e: 'close'): void;
  (e: 'toggle-open'): void;
}>();

const instance = getCurrentInstance();

const isSliderFacet = computed(() => ['FLOAT', 'INTEGER'].includes(props.facet.type));
const name = computed(() => factFinderNgNameCleaner(props.facet.name));

function registerElement(idx: number | null) {
  if (idx === 0 && props.registerDomElement) {
    props.registerDomElement(instance?.proxy?.$el);
  }
}

function onClose() {
  emit('close');
}

function toggleOpen() {
  emit('toggle-open');
}

function onChange(...params: any[]) {
  emit('change', ...params);
}

watch(
  () => props.idx,
  (newValue) => {
    registerElement(newValue);
  },
);

onMounted(() => {
  registerElement(props.idx);
});
</script>

<style src="./fact-finder-facet-fi-unscoped" />
